import 'css-chunk:src/app/components/InstagramMeta/MetaItems/Tables.scss';export default {
  "InstagramTable": "_InstagramTable_1hxuu_1",
  "InstagramTableFooter": "_InstagramTableFooter_1hxuu_6",
  "TableTitle": "_TableTitle_1hxuu_12",
  "EmptyAdAccounts": "_EmptyAdAccounts_1hxuu_16",
  "RowTable": "_RowTable_1hxuu_23",
  "RemoveButton": "_RemoveButton_1hxuu_26",
  "marginBottom": "_marginBottom_1hxuu_33"
};